var _circle, _circle2, _circle3, _path, _circle4, _path2, _path3, _circle5, _circle6, _path4, _path5, _path6, _path7, _circle7, _circle8, _circle9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1440,
    height: 236,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 48.805,
    fill: "#FFD771",
    transform: "matrix(-1 0 0 1 1360.8 115.805)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 9.873,
    stroke: "#FFD771",
    strokeWidth: 1.795,
    transform: "matrix(-1 0 0 1 34.77 87.77)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1197.73,
    cy: 98.73,
    r: 13.102,
    stroke: "#FFD771",
    strokeWidth: 1.255
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B8E5E8",
    fillRule: "evenodd",
    d: "m0 99 24 10.213c24 10.214 72 30.288 120 50.715 48 20.427 96 40.501 144 38.036 48-2.465 96-27.823 144-33.105 48-4.931 96 10.213 144 5.282 48-5.282 96-30.64 144-27.822 48 2.465 96 32.753 144 32.753s96-30.288 144-48.249c48-17.61 96-22.54 144-25.358 48-2.465 96-2.465 144 5.283 48 7.396 96 22.892 120 30.288l24 7.748V236H0V99Z",
    clipRule: "evenodd"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    r: 20,
    fill: "#FFD771",
    transform: "matrix(-1 0 0 1 229 129)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#41D2CA",
    d: "m73.283 190.705-39.962 23.072v-46.145l39.962 23.073Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#07878E",
    d: "m122.046 190.705-56.557 32.653v-65.307l56.557 32.654Z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 1396.73,
    cy: 73.73,
    r: 13.102,
    stroke: "#FFD771",
    strokeWidth: 1.255
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 63.532,
    cy: 59.532,
    r: 7.532,
    fill: "#FFD771"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#41D2CA",
    d: "m189.22 99.016-15.915 9.188V89.827l15.915 9.189Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#07878E",
    d: "m208.642 99.016-22.524 13.003V86.012l22.524 13.004Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#41D2CA",
    d: "m1285.36 43.418-46.02 26.569V16.849l46.02 26.57Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#07878E",
    d: "m1341.51 43.418-65.13 37.602V5.817l65.13 37.601Z"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 989.532,
    cy: 104.532,
    r: 7.532,
    fill: "#FFD771"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 296.001,
    cy: 95.001,
    r: 3.374,
    stroke: "#FFD771",
    strokeWidth: 1.255
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 1010,
    cy: 74.001,
    r: 3.374,
    fill: "#FFD771",
    stroke: "#FFD771",
    strokeWidth: 1.255
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadBg);
export default __webpack_public_path__ + "static/media/download-bg.32eab70707fafa2374161280961fded5.svg";
export { ForwardRef as ReactComponent };